import * as Sentry from "@sentry/react";
import { connectRouter, routerMiddleware } from 'connected-react-router';
import {
  applyMiddleware, combineReducers, compose, createStore
} from 'redux';
import thunk from 'redux-thunk';
import auditReducer from '~modules/Audit/reducers';
import authReducer from '~modules/Auth/reducer';
import companyReducer from '~modules/Companies/reducer';
import identificationReducer from '~modules/Identification/reducers';
import licenseReducer from '~modules/Licenses/reducer';
import statsReducer from '~modules/Statistics/reducer';
import subjectReducer from '~modules/Subject/reducer';
import featureFlagsReducer from '~modules/FeatureFlags/reducer';
import userReducer from '~modules/User/reducers';
import usersReducer from '~modules/Users/reducers';
import productSettingsReducer from '~modules/ProductSettings/reducer';
import surveyReducer from "~modules/Surveys/reducers";
import releaseNotesReducer from "~modules/ReleaseNotes/reducers";

const defaultReducers = {
  productSettingsReducer,
  companyReducer,
  identificationReducer,
  auditReducer,
  usersReducer,
  userReducer,
  licenseReducer,
  statsReducer,
  authReducer,
  subjectReducer,
  featureFlagsReducer,
  surveyReducer,
  releaseNotesReducer
};

export const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  ...defaultReducers
});

// @ts-ignore
const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  // @ts-ignore
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export const makeStore = (history) => createStore(
  rootReducer(history),
  composeEnhancers(applyMiddleware(thunk, routerMiddleware(history)), sentryReduxEnhancer)
);
